import { frontendURL } from '../../../helper/URLHelper';

const CrmEmbed = () => import('./CrmEmbed.vue');
const TelefoniaEmbed = () => import('./TelefoniaEmbed.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_embed',
    component: CrmEmbed,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/telefonia'),
    name: 'telefonia_embed',
    component: TelefoniaEmbed,
    meta: {
      permissions: ['administrator', 'custom_role'],
    },
  },
];

export default { routes };
